import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation.component';
import { MainNavigationModule } from './main-navigation/main-navigation.module';
import { PortalNavigationModule } from './portal-navigation/portal-navigation.module';
import { PortalService } from '../../portal/portal-service';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [NavigationComponent],
  imports: [
    CommonModule,
    RouterModule,
    MainNavigationModule,
    PortalNavigationModule,
  ],
  providers: [PortalService],
  exports: [NavigationComponent],
})
export class NavigationModule {}
